import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import QuestionRenderer from "../QuestionRenderer";
import RichTextDisplay from "../RichTextDisplay";

/**
 * Single question result block. Reuses the shared QuestionRenderer in
 * `showResult` / `disabled` mode so the visual presentation (choice
 * highlighting, fill-blank inline feedback, etc.) matches an active session.
 */
const ReviewQuestion = ({ item, displayNumber, theme }) => {
  if (!item?.question) return null;
  const { question, userAnswer, isCorrect, answered } = item;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography variant="subtitle1" fontWeight={700}>
          Question {displayNumber ?? question.number}
        </Typography>
        {!answered ? (
          <Chip label="Not answered" size="small" variant="outlined" />
        ) : isCorrect ? (
          <CheckCircleIcon color="success" fontSize="small" />
        ) : (
          <CancelIcon color="error" fontSize="small" />
        )}
      </Box>

      <QuestionRenderer
        question={question}
        answer={userAnswer}
        onAnswerChange={() => {}}
        showResult={true}
        disabled={true}
        questionNumber={displayNumber ?? question.number}
      />

      {question.explanation && (
        <Box
          sx={{
            mt: 1.5,
            p: 1.5,
            bgcolor: "grey.50",
            borderRadius: 1,
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography
            variant="caption"
            color="primary"
            fontWeight={700}
            sx={{ display: "block", mb: 0.5 }}
          >
            Explanation
          </Typography>
          <RichTextDisplay
            content={question.explanation}
            sx={{ fontSize: "0.9rem" }}
          />
        </Box>
      )}
    </Box>
  );
};

export default ReviewQuestion;
